import {
  TBlockRetailerData,
  TBlockScope,
  TBlockUnblockAdditionalDetails,
  TBlockUnblockRetailerData,
  TGetAllBlockUnblockDataParams,
  TGetAllBlockUnblockDataResponse,
  TGetBlockUnblockRetailerParams,
  TUnblockRetailerData,
} from '../utils/types';
import { emptySplitApi } from './emptySplitApi';

export const blockUnblockRetailerService = emptySplitApi
  .enhanceEndpoints({
    addTagTypes: ['allBlockUnblockData'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getBlockUnblockRetailer: builder.query<
        TBlockUnblockRetailerData[],
        TGetBlockUnblockRetailerParams
      >({
        query: ({ searchString, retailerId }) => ({
          url: 'block-service/block/list',
          method: 'GET',
          params: {
            page: 0,
            size: 1,
            searchKey: searchString,
            retailerId,
          },
        }),
      }),
      getBlockScopes: builder.query<TBlockScope[], void>({
        query: () => ({
          method: 'GET',
          url: 'block-service/block-scopes',
        }),
      }),
      getAllBlockUnblockData: builder.query<
        TGetAllBlockUnblockDataResponse,
        TGetAllBlockUnblockDataParams
      >({
        query: (params) => ({
          method: 'GET',
          url: 'block-service/block/status',
          params,
        }),
        providesTags: ['allBlockUnblockData'],
      }),
      retailerBlock: builder.mutation<
        TBlockUnblockRetailerData,
        TBlockRetailerData
      >({
        query: (data) => {
          return {
            url: 'block-service/block',
            method: 'POST',
            data,
          };
        },
        invalidatesTags: ['allBlockUnblockData'],
      }),
      retailerUnblock: builder.mutation<
        TBlockUnblockRetailerData,
        TUnblockRetailerData
      >({
        query: (data) => {
          return {
            url: 'block-service/unblock',
            method: 'PUT',
            data,
          };
        },
        invalidatesTags: ['allBlockUnblockData'],
      }),
      getAdditionalDetails: builder.query<
        {
          data: TBlockUnblockAdditionalDetails[];
          totalCount: number;
        },
        number
      >({
        query: (retailerId) => ({
          method: 'GET',
          url: 'retailer/flag/all/active',
          params: {
            page: 0,
            size: 10,
            retailerId,
          },
        }),
        transformResponse: (
          data: TBlockUnblockAdditionalDetails[],
          meta: Response
        ) => {
          const totalCount =
            meta.headers.get('X-total-count');
          return {
            data,
            totalCount: Number(totalCount ? totalCount : 0),
          };
        },
      }),
    }),
  });

export const {
  useGetBlockUnblockRetailerQuery,
  useGetBlockScopesQuery,
  useGetAllBlockUnblockDataQuery,
  useGetAdditionalDetailsQuery,
  useRetailerBlockMutation,
  useRetailerUnblockMutation,
} = blockUnblockRetailerService;
